import React from 'react';
import Header from '../components/Header';
import Breadcrumb from '../components/Breadcrumb';
import Footer from '../components/Footer';
import { LAST_REVIEWED, formatarData } from '../data/revision';

function Privacidade() {
  return (
    <div className="min-h-screen bg-gray-50 font-sans text-gray-900">
      <Header />
      <Breadcrumb />
      <main className="max-w-4xl mx-auto px-4 py-12">
        <span className="section-kicker">Privacidade</span>
        <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight mt-2 mb-4 text-slate-800">Política de Privacidade</h1>
        <p className="text-lg text-gray-600 mb-8">O princípio deste site é simples: a calculadora funciona sem cadastro e não precisa receber dados identificáveis do paciente.</p>

        <section className="bg-white border border-slate-200 rounded-2xl p-6 md:p-8 shadow-sm mb-6">
          <h2 className="text-2xl font-bold mb-3">O que a calculadora envia?</h2>
          <p className="text-gray-700">As seleções de O, V, M e pupilas são calculadas no próprio navegador. O site não envia esses valores por formulário para um backend nem cria prontuário, conta de usuário ou banco de dados de pacientes.</p>
        </section>

        <section className="bg-white border border-slate-200 rounded-2xl p-6 md:p-8 shadow-sm mb-6">
          <h2 className="text-2xl font-bold mb-3">Há cookies ou pixels de publicidade?</h2>
          <p className="text-gray-700">A aplicação não depende de cookies para calcular ou salvar o escore e não incorpora pixels publicitários no código da calculadora.</p>
        </section>

        <section className="bg-white border border-slate-200 rounded-2xl p-6 md:p-8 shadow-sm mb-6">
          <h2 className="text-2xl font-bold mb-3">E os logs da infraestrutura?</h2>
          <p className="text-gray-700">Como qualquer site entregue por CDN, requisições HTTP podem gerar metadados técnicos na infraestrutura de hospedagem e segurança, como endereço IP, user-agent, rota solicitada e horário. Esses dados de infraestrutura são distintos das respostas clínicas selecionadas na calculadora.</p>
        </section>

        <section className="bg-slate-900 text-white rounded-2xl p-6 md:p-8 mb-6">
          <h2 className="text-2xl font-bold text-white mb-3">Não coloque identificação de paciente na URL</h2>
          <p className="text-slate-100">A calculadora pode usar parâmetros técnicos para restaurar pontuações. Não acrescente nome, CPF, telefone, número de prontuário ou qualquer identificador do paciente à URL ou ao texto copiado fora do prontuário seguro.</p>
        </section>

        <p className="text-sm text-gray-500">Última atualização desta política: {formatarData(LAST_REVIEWED)}.</p>
      </main>
      <Footer />
    </div>
  );
}

export default Privacidade;
